import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Attachment } from "types/types";
import {
  CenteredCell,
  ListContextMenuIconButton,
} from "../../../../components/styled";
import { useSelector } from "../../../../store/hooks";

type Props = {
  attachments?: Attachment[] | null;
};

// Fleet level documents: an attachment icon with the count, opening a menu with one download link per document
const AttachmentsCell = ({ attachments }: Props) => {
  const { t } = useTranslation();
  const taxonomy = useSelector((s) => s.taxonomy);

  if (!attachments || attachments.length === 0) return null;

  const items: IContextualMenuItem[] = attachments.map((a) => ({
    key: String(a.attachmentId),
    text: a.attachmentName,
    secondaryText: t(taxonomy.AttachmentType.byId[a.attachmentTypeCode]?.code),
    iconProps: { iconName: "Download" },
    href: a.url ?? undefined,
    target: "_blank",
    rel: "noopener noreferrer",
    disabled: !a.url,
  }));

  return (
    <CenteredCell>
      <ListContextMenuIconButton
        iconProps={{ iconName: "Attach" }}
        title={
          t("bfm.vehicle.tabs.attachments") + " (" + attachments.length + ")"
        }
        menuIconProps={{ style: { display: "none" } }}
        menuProps={{ items }}
      />
      <span>{attachments.length}</span>
    </CenteredCell>
  );
};

export default AttachmentsCell;
